const reportEn = {
    installedEquipment: require('../../lang/en/report/InstalledEquipment').default,
    stockReport: require('../../lang/en/report/Stock').default,
    auditLog: require('../../lang/en/report/AuditLog').default,
};

export default reportEn;